<template>
  <HXContentCard title="Base Metas Mensuales">
    <div class="row p-4">
      <div class="col-12 col-lg-3">
        <b-button
          v-for="{ name, text } in optionsActions"
          class="w-100 my-1"
          :variant="name == selectedAction ? 'primary' : 'dark'"
          :key="name + 'action'"
          @click="selectedAction = name"
        >
          {{ text }}
        </b-button>
      </div>
      <div class="col-12 col-lg border rounded body-content-baseMetas">
        <form
          v-if="selectedAction == 'config'"
          class="row p-2"
          @submit.prevent="saveConfiguracion"
        >
          <div class="col-12 col-lg-6 mb-3">
            <label for="date" class="form-label">Mes y Año</label>
            <input
              id="date"
              type="month"
              class="form-control"
              v-model="forms[selectedAction].date"
              @input="handleDateInput"
              required
            />
          </div>

          <div class="col-12">
            <div class="row">
              <div
                v-for="field in forms[selectedAction].fields"
                :key="field.name"
                class="col-12 col-lg-6 mb-3"
              >
                <label :for="field.name" class="form-label">{{
                  field.label
                }}</label>
                <input
                  :type="field.type"
                  v-model="field.value"
                  class="form-control"
                  required
                />
              </div>
            </div>
          </div>

          <vs-button success class="ml-auto" type="submit">
            Guardar Cambios
          </vs-button>
        </form>

        <form v-else class="row p-2" @submit.prevent="saveBaseMetas">
          <div class="col-12 col-lg-6 mb-3">
            <label for="date" class="form-label">Mes y Año</label>
            <input
              id="date"
              type="month"
              class="form-control"
              v-model="forms[selectedAction].date"
              required
            />
          </div>

          <div
            v-for="zona in forms[selectedAction].zonas"
            :key="zona.name"
            class="col-12"
          >
            <b class="w-100 text-center d-block py-2">
              {{ zona.name }}
            </b>
            <div
              class="row align-items-center my-2"
              v-for="ubicacion in zona.ubicaciones"
              :key="ubicacion.name"
            >
              <div class="col-12 col-lg-6">
                <label for="" class="form-label">Ubicacion</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="ubicacion.name"
                  required
                />
              </div>
              <div class="col-12 col-lg-6">
                <label for="" class="form-label">Meta Mensual</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="ubicacion.metaMensual"
                  required
                />
              </div>
            </div>
          </div>

          <vs-button success class="ml-auto" type="submit">
            Guardar Cambios
          </vs-button>
        </form>
      </div>
    </div>
  </HXContentCard>
</template>

<script>
import Holidays from "date-holidays";
// eslint-disable-next-line no-unused-vars
import { eachDayOfInterval, isWeekend, format } from "date-fns";
const Swal = require("sweetalert2");

export default {
  data() {
    return {
      listaConfiguraciones: [],
      ListaBaseMetas: [],
      optionsActions: [
        {
          name: "config",
          text: "Configuracion Mensual",
        },
        {
          name: "baseMetas",
          text: "Base Metas",
        },
      ],
      selectedAction: "config",
      forms: {
        config: {
          date: null,
          fields: [
            {
              type: "number",
              name: "diasHabiles",
              label: "Dias Habiles",
              value: 0,
            },
            {
              type: "number",
              name: "porcentajePrimerAbono",
              label: "% Primer Abono",
              value: 87,
            },
            {
              type: "number",
              name: "porcentajeSegundoAbono",
              label: "% Segundo Abono",
              value: 13,
            },
            {
              type: "number",
              name: "metaGeneralV1",
              label: "Eficacia",
              value: 1380,
            },
          ],
        },
        baseMetas: {
          date: null,
          zonas: [
            {
              name: "ZONA 1",
              ubicaciones: [
                { name: "CALI AV 6TA", metaMensual: 151900 },
                { name: "CALI CIUDAD JARDIN", metaMensual: 170900 },
                { name: "CALI CALIMA", metaMensual: 223900 },
                { name: "MALL PLAZA CALI", metaMensual: 218900 },
                { name: "MALL PLAZA BARRANQUILLA", metaMensual: 204900 },
              ],
            },
            {
              name: "ZONA 2",
              ubicaciones: [
                { name: "ITAGUI", metaMensual: 192900 },
                { name: "LA PLAYA", metaMensual: 280900 },
                { name: "POBLADO", metaMensual: 124900 },
                { name: "VILLAS", metaMensual: 152000 },
                { name: "COLSUBSIDIO", metaMensual: 190900 },
                { name: "PORTAL 80", metaMensual: 189900 },
              ],
            },
            {
              name: "ZONA 3",
              ubicaciones: [
                { name: "CALLE 80", metaMensual: 201900 },
                { name: "MULTIPLAZA", metaMensual: 277900 },
                { name: "SALITRE", metaMensual: 151900 },
                { name: "SUBA PLAZA IMPERIAL", metaMensual: 399900 },
                { name: "TUNAL", metaMensual: 150900 },
                { name: "CEDRITOS", metaMensual: 278900 },
                { name: "VILLAVICENCIO", metaMensual: 239900 },
              ],
            },
            {
              name: "ZONA 4",
              ubicaciones: [
                { name: "ALAMOS", metaMensual: 175000 },
                { name: "KENNEDY", metaMensual: 442900 },
                { name: "CENTRO", metaMensual: 126000 },
                { name: "MALL PLAZA BOGOTA", metaMensual: 151900 },
                { name: "PASEO VILLA DEL RIO", metaMensual: 153900 },
                { name: "ROMA", metaMensual: 186900 },
              ],
            },
            {
              name: "ZONA 5",
              ubicaciones: [
                { name: "CENTRO MAYOR", metaMensual: 308900 },
                { name: "CHAPINERO", metaMensual: 191900 },
                { name: "GRAN ESTACION", metaMensual: 195500 },
                { name: "PLAZA DE LAS AMERICAS", metaMensual: 238900 },
                { name: "UNICENTRO", metaMensual: 150900 },
                { name: "SOACHA", metaMensual: 245900 },
              ],
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.getListaConfiguraciones();
    this.getListaBaseMetas();
  },
  methods: {
    async getListaConfiguraciones() {
      try {
        this.$isLoading(true);
        let res = await this.$store.dispatch("denti_get", {
          path: "BaseMetasMensuales/ListaConfiguraciones",
        });
        console.log("lista configuraciones", res);
        this.listaConfiguraciones = res;

        if (res && res.length > 0) {
          // Ordenar por fecha descendente (año y luego mes)
          const registroMasReciente = res.sort((a, b) => {
            if (b.anio === a.anio) {
              return b.mes - a.mes; // Comparar por mes si el año es el mismo
            }
            return b.anio - a.anio; // Comparar por año
          })[0];

          console.log("registroMasReciente", registroMasReciente);

          this.forms.config.date = `${registroMasReciente.anio}-${registroMasReciente.mes}`;
          this.forms.config.fields.forEach((field) => {
            field.value = registroMasReciente[field.name];
          });
        }
        this.$isLoading(false);
      } catch (error) {
        this.listaConfiguraciones = [];
        this.$isLoading(false);
      }
    },
    async getListaBaseMetas() {
      this.$isLoading(true);
      try {
        let res = await this.$store.dispatch("denti_get", {
          path: "BaseMetasMensuales/ListaBaseMetas",
        });
        console.log("lista base metas", res);
        this.listaBaseMetas = res;

        if (res && res.length > 0) {
          // Ordenar por fecha descendente (año y luego mes)
          const registroMasReciente = res.sort((a, b) => {
            if (b.anio === a.anio) {
              return b.mes - a.mes; // Comparar por mes si el año es el mismo
            }
            return b.anio - a.anio; // Comparar por año
          })[0];

          // Filtrar los registros con la misma fecha que el más reciente
          const registrosFechaMasReciente = res.filter(
            (item) =>
              item.anio === registroMasReciente.anio &&
              item.mes === registroMasReciente.mes
          );

          console.log(
            "Registros con la fecha más reciente:",
            registrosFechaMasReciente
          );

          // Mapear los datos en el formato de zonas y ubicaciones
          const zonas = registrosFechaMasReciente.reduce((acc, item) => {
            let zona = acc.find((z) => z.name === item.zona);
            if (!zona) {
              zona = { name: item.zona, ubicaciones: [] };
              acc.push(zona);
            }
            zona.ubicaciones.push({
              name: item.ubicacion,
              metaMensual: item.metaMensual,
            });
            return acc;
          }, []);

          console.log("zonas", zonas);

          // Asignar al formulario
          this.forms.baseMetas.date = `${registroMasReciente.anio}-${registroMasReciente.mes}`;
          this.forms.baseMetas.zonas = zonas;
        }
        this.$isLoading(false);
      } catch (error) {
        this.listaBaseMetas = [];
        this.$isLoading(false);
        console.log("error", error);
      }
    },
    async saveConfiguracion() {
      this.$isLoading(true);
      try {
        console.log("save configuracion", this.forms.config);

        const { date, fields } = this.forms.config;

        const [anio, mes] = date.split("-").map(Number);

        console.log(anio, mes, fields);

        const extractedFields = fields.reduce((acc, field) => {
          const { name, value } = field;
          acc[name] = value;
          return acc;
        }, {});

        console.log("extractedFields", extractedFields);

        let data = {
          mes,
          anio,
          ...extractedFields,
        };

        console.log("data", data);

        let res = await this.$store.dispatch("denti_post", {
          path: "BaseMetasMensuales/CrearConfiguracion",
          data,
        });
        console.log("res", res);

        if (res.id) {
          Swal.fire(
            "Listo!",
            "Se ha creado la configuración correctamente.",
            "success"
          );
          this.listaConfiguraciones.push(res);
        } else {
          Swal.fire(
            "Error!",
            "Ya existe una configuración para este mes.",
            "error"
          );
        }
        this.$isLoading(false);
      } catch (error) {
        console.log("error", error);
        this.$isLoading(false);
        Swal.fire("Error!", "Error: " + error, "error");
      }
    },
    async saveBaseMetas() {
      this.$isLoading(true);
      try {
        console.log("save base metas", this.forms.baseMetas);

        const { date, zonas } = this.forms.baseMetas;

        const [anio, mes] = date.split("-").map(Number);

        // Transformar las zonas y ubicaciones en un formato plano
        const data = zonas.flatMap((zona) =>
          zona.ubicaciones.map((ubicacion) => ({
            anio,
            mes,
            zona: zona.name,
            ubicacion: ubicacion.name,
            metaMensual: ubicacion.metaMensual,
          }))
        );
        console.log("Datos a enviar:", data);

        let exitos = [];
        let errores = [];

        // Enviar cada registro por separado
        for (const item of data) {
          try {
            console.log("Enviando registro:", item);

            let res = await this.$store.dispatch("denti_post", {
              path: "BaseMetasMensuales/CrearBaseMetas",
              data: item,
            });

            console.log("Respuesta del backend:", res);

            if (res.id) {
              exitos.push(item); // Registro exitoso
              this.listaBaseMetas.push(res);
            } else {
              errores.push(item); // Registro con error
            }
          } catch (error) {
            console.error("Error en registro:", item, error);
            errores.push(item); // Error durante la solicitud
          }
        }

        // Mostrar alertas al final
        if (errores.length === 0) {
          Swal.fire(
            "Listo!",
            "Todos los registros se guardaron correctamente.",
            "success"
          );
        } else if (exitos.length > 0) {
          Swal.fire(
            "Atención!",
            `Algunos registros se guardaron correctamente (${exitos.length}), pero otros fallaron (${errores.length}).`,
            "warning"
          );
        } else {
          Swal.fire(
            "Error!",
            "Ningún registro se pudo guardar. Ya existe una base de metas para este mes.",
            "error"
          );
        }
        this.$isLoading(false);
      } catch (error) {
        console.log("error", error);
        this.$isLoading(false);
        Swal.fire("Error!", "Error: " + error, "error");
      }
    },
    handleDateInput(event) {
      const fecha = event.target.value; // Formato 'YYYY-MM'
      if (fecha) {
        const [anio, mes] = fecha.split("-").map(Number);
        console.log(anio, mes);

        this.getDiasHabiles(anio, mes);
      }
    },
    getDiasHabiles(anio, mes) {
      const diasHabiles = this.obtenerDiasHabiles(anio, mes);
      console.log(diasHabiles);

      const campoDiasHabiles = this.forms.config.fields.find(
        (f) => f.name === "diasHabiles"
      );
      if (campoDiasHabiles) {
        campoDiasHabiles.value = diasHabiles.length;
      }
    },
    obtenerDiasHabiles(anio, mes) {
      const hd = new Holidays("CO");
      const inicio = new Date(anio, mes - 1, 1);
      const fin = new Date(anio, mes, 0);
      const dias = eachDayOfInterval({ start: inicio, end: fin });
      const festivos = hd
        .getHolidays(anio)
        .filter((festivo) => {
          const fechaFestivo = new Date(festivo.date);
          return fechaFestivo.getMonth() + 1 === mes;
        })
        .map((festivo) => format(new Date(festivo.date), "yyyy-MM-dd"));

      // const diasHabiles = dias.filter(dia => {
      //   const esFinDeSemana = isWeekend(dia);
      //   const esFestivo = festivos.includes(format(dia, 'yyyy-MM-dd'));
      //   return !esFinDeSemana && !esFestivo;
      // });

      // Filtrar días hábiles incluye sabados
      const diasHabiles = dias.filter((dia) => {
        const diaSemana = dia.getDay(); // 0: Domingo, 1: Lunes, ..., 6: Sábado
        const esDomingo = diaSemana === 0; // Solo Domingo
        const esFestivo = festivos.includes(format(dia, "yyyy-MM-dd"));
        return !esDomingo && !esFestivo;
      });

      return diasHabiles.map((dia) => format(dia, "yyyy-MM-dd"));
    },
  },
};
</script>

<style lang="scss" scoped>
.body-content-baseMetas {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
